import {
  label_default
} from "../../chunk-X6MMFO33.js";
export {
  label_default as default
};
